import { TPalette } from '@shared/tokens/palette.stylex.ts';

export const CATEGORY_COLORS = ['RED', 'GREEN', 'BLUE', 'YELLOW', 'BROWN', 'VIOLET', 'PURPLE', 'TURQUOISE', 'GREY'];

export const DEFAULT_COLOR = 'DEFAULT';

export const mapColorToPalette: Record<string, keyof TPalette> = {
  RED: 'red-400',
  GREEN: 'green-400',
  BLUE: 'blue-400',
  YELLOW: 'yellow-400',
  BROWN: 'orange-400',
  VIOLET: 'lilac-400',
  PURPLE: 'rose-400',
  TURQUOISE: 'cyan-400',
  GREY: 'grey-400',
};
